module.exports = __webpack_public_path__ + "img/x-circle.8e2f7ef9.svg";